<template>
  <a-modal-wrapper
    :modal-name="MODAL.LIVEBYTES"
    :close-button="false"
    :width="350"
    :disable-scroll-wrapper-styles="true"
    class="livebytes_modal"
  >
    <live-bytes
      :is-in-modal="true"
      @scroll-state-changed="handleScrollStateChanged"
    />
    <div class="livebytes__fade-bottom" :class="scrollBottomDynamicClass" />
  </a-modal-wrapper>
</template>

<script>
import AModalWrapper, { MODAL } from 'modals/AModalWrapper'
import LiveBytes from '@/components/_layout/ASidebar/LiveBytes'

export default {
  name: 'ALiveBytesModal',
  components: { LiveBytes, AModalWrapper },
  data() {
    return {
      MODAL,
      isScrollAtBottom: false
    }
  },
  computed: {
    scrollBottomDynamicClass() {
      return { 'livebytes_modal-scroll-bottom': this.isScrollAtBottom }
    }
  },
  methods: {
    handleScrollStateChanged({ isScrollAtBottom }) {
      this.isScrollAtBottom = isScrollAtBottom
    }
  }
}
</script>

<style lang="scss" scoped>
.livebytes_modal {
  justify-content: flex-end;

  /deep/ .modal-wrapper__content-wrapper {
    position: fixed;
    margin: 0;
    background: $g--radial-main, $c--white;
    border-radius: 0;
    z-index: 2;

    & > * {
      z-index: 2;
    }
  }

  .livebytes__fade-bottom {
    display: block;
    width: 100%;
    height: 160px;
    position: absolute;
    z-index: 3;
    bottom: 0;
    left: 0;
    background: linear-gradient(
      180deg,
      rgba(230, 215, 255, 0) 0%,
      rgba(230, 215, 255, 0.4) 30%,
      rgba(230, 215, 255, 0.8) 60%,
      rgba(230, 215, 255, 0.95) 85%,
      #e6d7ff 100%
    );
    pointer-events: none;

    @include mobile {
      height: 150px;
    }

    &.livebytes_modal-scroll-bottom {
      opacity: 0;
    }
  }
}

/deep/ .live-bytes__image-modal {
  .modal-wrapper__content-wrapper {
    position: relative;
    margin: auto;
  }
}
</style>
